import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Zap, HeartHandshake, Shield } from 'lucide-react';
export function Pricing() {
  return <SectionWrapper id="pricing" className="px-4 md:px-12 max-w-4xl mx-auto py-20" data-id="element-118">
      <div className="text-center mb-12" data-id="element-119">
        <h2 className="text-4xl md:text-5xl font-playfair text-forest mb-4" data-id="element-120">
          Obtén Tu Guía Completa
        </h2>
        <p className="text-xl text-brown/80" data-id="element-121">
          Empieza a crear tus propios remedios naturales hoy mismo.
        </p>
      </div>

      <div className="relative max-w-2xl mx-auto" data-id="element-122">
        {/* Animated Glow Ring */}
        <motion.div animate={{
        opacity: [0.3, 0.6, 0.3]
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute -inset-1 bg-gradient-to-r from-amber to-sage rounded-[2rem] blur-md z-0" data-id="element-123"></motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-card rounded-3xl shadow-2xl border-2 border-amber relative z-10 overflow-hidden" data-id="element-124">
          {/* Highlight Banner */}
          <div className="bg-amber text-white text-center py-2 font-bold tracking-wider text-sm uppercase" data-id="element-125">
            Oferta Especial Limitada
          </div>

          <div className="p-8 md:p-12" data-id="element-126">
            <h3 className="text-3xl font-playfair text-forest text-center mb-2" data-id="element-127">
              Pomadas Naturales: Guía Práctica
            </h3>

            <div className="flex justify-center items-baseline my-8" data-id="element-128">
              <span className="text-2xl text-brown/50 line-through mr-4 font-medium" data-id="element-129">
                $19.99
              </span>
              <span className="text-6xl font-playfair font-bold text-forest" data-id="element-130">
                $9.99
              </span>
              <span className="text-lg text-brown/70 ml-2" data-id="element-131">USD</span>
            </div>

            <ul className="space-y-4 mb-10 max-w-md mx-auto" data-id="element-132">
              {['Guía completa en formato digital (PDF)', '6 recetas detalladas paso a paso', 'Lista de ingredientes y materiales', 'Consejos de almacenamiento', 'Base universal adaptable a tus necesidades'].map((item, idx) => <li key={idx} className="flex items-start" data-id="element-133">
                  <Check className="w-6 h-6 text-sage shrink-0 mr-3" data-id="element-134" />
                  <span className="text-lg text-brown/90" data-id="element-135">{item}</span>
                </li>)}
            </ul>

            <motion.button animate={{
            scale: [1, 1.02, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="w-full bg-amber text-white py-5 rounded-full font-bold text-xl hover:bg-amber/90 transition-colors shadow-lg mb-6" data-id="element-136">
              Comprar Ahora
            </motion.button>

            <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 text-sm text-brown/60 font-medium mb-8" data-id="element-137">
              <div className="flex items-center" data-id="element-138">
                <Zap className="w-4 h-4 mr-2 text-amber" data-id="element-139" /> Descarga inmediata
              </div>
              <div className="flex items-center" data-id="element-140">
                <ShieldCheck className="w-4 h-4 mr-2 text-forest" data-id="element-141" /> Pago seguro
              </div>
              <div className="flex items-center" data-id="element-142">
                <HeartHandshake className="w-4 h-4 mr-2 text-sage" data-id="element-143" />{' '}
                Satisfacción garantizada
              </div>
            </div>

            {/* Guarantee Box */}
            <div className="bg-sage/10 border border-sage/30 rounded-xl p-4 flex items-start" data-id="element-144">
              <Shield className="w-8 h-8 text-forest shrink-0 mr-4 mt-1" data-id="element-145" />
              <div data-id="element-146">
                <h4 className="font-playfair font-bold text-forest mb-1" data-id="element-147">
                  30 días de garantía
                </h4>
                <p className="text-sm text-brown/80 leading-relaxed" data-id="element-148">
                  Si no estás satisfecho con la guía, te devolvemos tu dinero.
                  Sin preguntas. Queremos que estés 100% feliz con tu compra.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </SectionWrapper>;
}